module.exports = __webpack_public_path__ + "media/img/kim-654aaf0d9c43a6f731405dcbfa6b4fa4.jpg";